import { generateHeadersCfTns } from "../auth/authFunctions";
import { apiAriannaGW, apiAriannaTS } from "./api";

export const checkScreeningCLApiTS = async () => {
    return await apiAriannaTS.get('/api/patient/check/CL', { headers: generateHeadersCfTns() });
}

export const checkScreeningCLApiSPID = async () => {
    return await apiAriannaGW.get('/patient/check/CL');
}


export const postDeclineCLApiTS = async () => {
    return await apiAriannaTS.post('/api/patient/decline', { headers: generateHeadersCfTns() });
}

export const postDeclineCLApiSPID = async () => {
    return await apiAriannaGW.post('/patient/decline');
}

export const postAdhesionCLApiTS = async (withdrawalMethod) => {
    return await apiAriannaTS.post("/api/patient/adhesion",
        {
            screeningTypeCode: 'CL',
            withrawalMethod: withdrawalMethod
        },
        { headers: generateHeadersCfTns() });
}

export const postAdhesionCLApiSPID = async (withdrawalMethod) => {
    return await apiAriannaGW.post("/patient/adhesion",
        {
            screeningTypeCode: 'CL',
            withrawalMethod: withdrawalMethod
        });
}

export const getDeclineReasonsCLApiTS = async () => {
    return await apiAriannaTS.get("/api/patient/decline/decline-reasons/CL", { headers: generateHeadersCfTns() });
}

export const getDeclineReasonsCLApiSPID = async () => {
    return await apiAriannaGW.get('/patient/decline/decline-reasons/CL');
}

export const getCollectionCenterByLevelCLApiTS = async () => {
    return await apiAriannaTS.get("/api/collection-center/by-level?screeningTypeCode=CL&screeningLevel=1", { headers: generateHeadersCfTns() });
}

export const getCollectionCenterByLevelCLApiSPID = async () => {
    return await apiAriannaGW.get("/collection-center/by-level?screeningTypeCode=CL&screeningLevel=1");
}